(function () {
  'use strict';

  function initBOHero(root) {
    if (!root || root.dataset.boHeroReady === 'true') return;

    var track = root.querySelector('[data-bo-hero-track]');
    var viewport = root.querySelector('[data-bo-hero-viewport]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-bo-hero-slide]'));
    if (!track || !viewport || !slides.length) return;

    root.dataset.boHeroReady = 'true';

    var current = 0;
    var timer = null;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && slides.length > 1;
    var mqMobile = window.matchMedia('(max-width: 749px)');
    var startX = null;
    var startY = null;
    var pointerStartX = null;
    var pointerStartY = null;
    var heroInView = true;
    var soundEnabled = false;

    var prev = root.querySelector('[data-bo-hero-prev]');
    var next = root.querySelector('[data-bo-hero-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bo-hero-dot]'));
    var soundButton = root.querySelector('[data-bo-hero-sound]');

    function visibleVideoSelector() {
      return mqMobile.matches
        ? '.bo-hero-split__mobile-media [data-bo-hero-video]'
        : '.bo-hero-split__desktop-media [data-bo-hero-video]';
    }

    function mediaWrapper(video) {
      return video ? video.closest('[data-bo-hero-media]') : null;
    }

    function activeVisibleVideos() {
      var active = slides[current];
      if (!active) return [];
      return Array.prototype.slice.call(active.querySelectorAll(visibleVideoSelector()));
    }

    function primaryAudioVideo() {
      var videos = activeVisibleVideos();
      return videos.length ? videos[0] : null;
    }

    function markVideoReady(video) {
      if (!video) return;
      video.classList.add('is-ready');
      var wrapper = mediaWrapper(video);
      if (wrapper) wrapper.classList.add('is-video-ready');
    }

    function markVideoPlaying(video) {
      if (!video) return;
      markVideoReady(video);
      video.classList.add('is-playing');
      var wrapper = mediaWrapper(video);
      if (wrapper) wrapper.classList.add('is-video-playing');
    }

    function ensureMuted(video) {
      if (!video) return;
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
    }

    function bindVideo(video) {
      if (!video || video.dataset.boVideoBound === 'true') return;
      video.dataset.boVideoBound = 'true';

      ensureMuted(video);
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      video.addEventListener('playing', function () {
        markVideoPlaying(video);
      }, { passive: true });

      video.addEventListener('loadeddata', function () {
        if (!video.paused || video.currentTime > 0) markVideoReady(video);
      }, { passive: true });

      video.addEventListener('error', function () {
        video.classList.remove('is-ready', 'is-playing');
        var wrapper = mediaWrapper(video);
        if (wrapper) wrapper.classList.remove('is-video-ready', 'is-video-playing');
      }, { passive: true });
    }

    root.querySelectorAll('[data-bo-hero-video]').forEach(bindVideo);

    function updateSoundButton() {
      if (!soundButton) return;
      var hasVideo = activeVisibleVideos().length > 0;
      soundButton.hidden = !hasVideo;
      soundButton.classList.toggle('is-sound-on', soundEnabled && hasVideo);
      soundButton.setAttribute('aria-pressed', soundEnabled && hasVideo ? 'true' : 'false');
      soundButton.setAttribute('aria-label', soundEnabled && hasVideo ? 'Silenciar video' : 'Activar sonido');
      soundButton.title = soundEnabled && hasVideo ? 'Silenciar' : 'Activar sonido';
    }

    function muteEveryVideo() {
      root.querySelectorAll('[data-bo-hero-video]').forEach(function (video) {
        ensureMuted(video);
      });
    }

    function setSound(enabled, userInitiated) {
      soundEnabled = Boolean(enabled) && heroInView && !document.hidden;
      muteEveryVideo();

      if (soundEnabled) {
        var primary = primaryAudioVideo();
        if (primary) {
          /* Unmuting must happen inside the button's user gesture on Safari/iOS. */
          primary.muted = false;
          primary.defaultMuted = false;
          primary.removeAttribute('muted');
          if (userInitiated) {
            try {
              var p = primary.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } catch (e) {}
          }
        }
      }
      updateSoundButton();
    }

    function pauseAllVideos(reset) {
      root.querySelectorAll('[data-bo-hero-video]').forEach(function (video) {
        try {
          video.pause();
          video.classList.remove('is-playing');
          var wrapper = mediaWrapper(video);
          if (wrapper) wrapper.classList.remove('is-video-playing');
          if (reset && video.readyState > 0) video.currentTime = 0;
          if (!video.closest('.is-active')) {
            video.autoplay = false;
            video.removeAttribute('autoplay');
            video.preload = 'none';
          }
        } catch (e) {}
      });
    }

    function playVideo(video, reset) {
      if (!video || document.hidden || !heroInView) return;
      bindVideo(video);

      try {
        /* Always start/resume muted. Audio is enabled only by the explicit button. */
        if (!soundEnabled || video !== primaryAudioVideo()) ensureMuted(video);
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.autoplay = true;
        video.setAttribute('autoplay', 'autoplay');
        video.preload = 'auto';

        if (reset && video.readyState > 0) video.currentTime = 0;
        if (video.readyState === 0) {
          try { video.load(); } catch (e) {}
        }

        var promise = video.play();
        if (promise && typeof promise.then === 'function') {
          promise.then(function () {
            markVideoPlaying(video);
          }).catch(function () {
            /* Keep the poster visible and retry when Safari reports it can play. */
            var retry = function () {
              if (document.hidden || !heroInView) return;
              try {
                var retryPromise = video.play();
                if (retryPromise && typeof retryPromise.catch === 'function') {
                  retryPromise.catch(function () {});
                }
              } catch (e) {}
            };
            video.addEventListener('canplay', retry, { once: true, passive: true });
          });
        }
      } catch (e) {}
    }

    function playActiveVideos(reset) {
      pauseAllVideos(false);
      activeVisibleVideos().forEach(function (video) {
        playVideo(video, reset);
      });
      /* If the visitor had enabled sound, keep only the primary video audible. */
      if (soundEnabled) setSound(true, false);
      updateSoundButton();
    }

    function durationFor(index) {
      var seconds = parseInt(slides[index].getAttribute('data-duration'), 10);
      if (!seconds || seconds < 4) seconds = 8;
      return seconds * 1000;
    }

    function clearTimer() {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    }

    function schedule() {
      clearTimer();
      if (!autoplay || document.hidden || !heroInView) return;
      timer = window.setTimeout(function () {
        goTo(current + 1, true);
      }, durationFor(current));
    }

    function updateDots() {
      dots.forEach(function (dot, index) {
        var active = index === current;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function goTo(index, resetVideo) {
      if (!slides.length) return;
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;

      track.style.transform = 'translate3d(' + (-100 * current) + '%,0,0)';
      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      updateDots();
      playActiveVideos(resetVideo !== false);
      schedule();
    }

    if (soundButton) {
      soundButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setSound(!soundEnabled, true);
      });
    }

    if (prev) prev.addEventListener('click', function () { goTo(current - 1, true); });
    if (next) next.addEventListener('click', function () { goTo(current + 1, true); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-bo-hero-dot'), 10) || 0, true);
      });
    });

    viewport.addEventListener('touchstart', function (event) {
      if (!event.touches || !event.touches[0]) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });

    viewport.addEventListener('touchend', function (event) {
      if (startX === null || !event.changedTouches || !event.changedTouches[0]) return;
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      startX = null;
      startY = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.25) {
        goTo(current + (dx < 0 ? 1 : -1), true);
      }
    }, { passive: true });

    viewport.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') return;
      if (event.target.closest('a,button')) return;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
    });

    viewport.addEventListener('pointerup', function (event) {
      if (pointerStartX === null) return;
      var dx = event.clientX - pointerStartX;
      var dy = event.clientY - pointerStartY;
      pointerStartX = null;
      pointerStartY = null;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.25) {
        goTo(current + (dx < 0 ? 1 : -1), true);
      }
    });

    function mediaChanged() {
      setSound(false, false);
      playActiveVideos(false);
    }

    if (typeof mqMobile.addEventListener === 'function') mqMobile.addEventListener('change', mediaChanged);
    else if (typeof mqMobile.addListener === 'function') mqMobile.addListener(mediaChanged);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          heroInView = entry.isIntersecting && entry.intersectionRatio > 0.08;
          if (heroInView) {
            /* Resume muted when returning to the hero; never restart audio unexpectedly. */
            setSound(false, false);
            playActiveVideos(false);
            schedule();
          } else {
            clearTimer();
            setSound(false, false);
            pauseAllVideos(false);
          }
        });
      }, { threshold: [0, 0.08, 0.25] });
      observer.observe(root);
      root._boHeroObserver = observer;
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearTimer();
        setSound(false, false);
        pauseAllVideos(false);
      } else if (heroInView) {
        playActiveVideos(false);
        schedule();
      }
    });

    root._boHeroGoTo = goTo;
    root._boHeroDestroy = function () {
      clearTimer();
      setSound(false, false);
      pauseAllVideos(false);
      if (root._boHeroObserver) root._boHeroObserver.disconnect();
      root.dataset.boHeroReady = 'false';
    };

    /* First slide: HTML already contains autoplay+muted. This call keeps desktop,
       Android and Safari behavior aligned and activates only the visible device copy. */
    goTo(0, false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-bo-hero-split]').forEach(initBOHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-bo-hero-split]');
    if (root && root._boHeroDestroy) root._boHeroDestroy();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    if (!block || !block.matches || !block.matches('[data-bo-hero-slide]')) return;
    var root = block.closest('[data-bo-hero-split]');
    if (!root || !root._boHeroGoTo) return;
    var index = parseInt(block.getAttribute('data-slide-index'), 10) || 0;
    root._boHeroGoTo(index, true);
  });
})();
